import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  Input,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { ModalController, Platform, PopoverController } from '@ionic/angular';
import { lastValueFrom } from 'rxjs';
import { NotificationDialogComponent } from 'src/app/molecules/notification-dialog/notification-dialog.component';
import { KioskMode } from 'src/app/plugins/kiosk-mode';
import { AuthService } from 'src/app/services/auth.service';
import { NotificationService } from 'src/app/services/notification.service';
import { SharedStateService } from 'src/app/services/sharedState.service';
import { SignalRService } from 'src/app/services/signalR.service';
import {
  UserStatusDto,
  UserStatusServiceFactory,
} from 'src/app/services/user-status.service';
import { getUserStatus } from 'src/app/services/utils';
import { System } from 'src/app/services/utils/constants';
import { SettingSubmenuPopoverComponent } from '../setting-submenu-popover/setting-submenu-popover.component';

@Component({
  selector: 'rfr-horizontal-menu',
  templateUrl: './rfr-horizontal-menu.component.html',
  styleUrls: ['./rfr-horizontal-menu.component.scss'],
})
export class RfrHorizontalMenuComponent implements OnInit {
  isShowUserStatus: boolean = true;
  @Input() tenantInfo: any;
  @Input() toolbarColor = 'blue';
  constrastColor = 'dark';
  readNotify = '0';
  popover: any;
  isSubscribedNotification = false;
  totaUnreadlNotifications = '0';
  userStatus: any;
  user: any;
  isMobile!: boolean;
  isKioskMode = false;
  constructor(
    private router: Router,
    public modalCtrl: ModalController,
    private authService: AuthService,
    private signalRService: SignalRService,
    private notificationService: NotificationService,
    private sharedStateService: SharedStateService,
    private userStatusService: UserStatusServiceFactory,
    private platform: Platform,
    private popoverController: PopoverController
  ) {
    this.isMobile =
      this.platform.is('mobile') && !this.platform.is('mobileweb');
  }

  async ngOnInit() {
    if (this.toolbarColor == 'blue') {
      this.constrastColor = 'dark';
    } else {
      this.constrastColor = 'blue';
    }

    const isNativeApp = Capacitor.isNativePlatform();
    
    const isAndroid = Capacitor.getPlatform() === 'android';
    if (isNativeApp && isAndroid) {
      const checkKioskMode = await KioskMode.hasKioskMode();
      if(checkKioskMode.support == true){
        this.isKioskMode = true;
      }
    }

    this.getUnreadNotification();

    const tenantId = this.authService.currentUserValue.tenantId;
    const userId = this.authService.currentUserValue.user_id;

    this.user = this.authService.currentUserValue;

    if (userId && tenantId) {
      this.watchStatus(tenantId, userId);
      const currentStatus =
        (await lastValueFrom(
          this.userStatusService.getUserStatus(tenantId, userId)
        )) ?? this.userStatusService.getDefaultUserStatusDto(userId);

      if (currentStatus) {
        this.userStatus = getUserStatus(
          currentStatus.status as System.UserStatusClientEventType
        );
      }
    }
  }

  showStatusPopup = false;
  longPressTimeout: any;

  onHover() {
    if (!this.isMobile) {
      this.showStatusPopup = true;
    }
  }

  onLeave() {
    if (!this.isMobile) {
      this.showStatusPopup = false;
    }
  }

  onTouchStart() {
    if (this.isMobile) {
      this.longPressTimeout = setTimeout(() => {
        this.showStatusPopup = true;
      }, 500); // 500ms hold
    }
  }

  onTouchEnd() {
    if (this.isMobile) {
      clearTimeout(this.longPressTimeout);
    }
  }

  onMouseDown() {
    // Optional: Handle long press on mobile via mouse (some Android browsers)
    if (this.isMobile) {
      this.longPressTimeout = setTimeout(() => {
        this.showStatusPopup = true;
      }, 500);
    }
  }

  onMouseUp() {
    if (this.isMobile) {
      clearTimeout(this.longPressTimeout);
    }
  }

  setStatus(status: string) {
    // logic to update user status
    console.log('Status changed to:', status);
    this.showStatusPopup = false;
  }

  private async watchStatus(tenantId: string, userId: string) {
    this.userStatusService
      .listenToMyStatus(tenantId, userId)
      .subscribe((res: UserStatusDto | null) => {
        console.log('res', res);

        if (!res) res = this.userStatusService.getDefaultUserStatusDto(userId);

        this.userStatus = getUserStatus(
          res?.status as System.UserStatusClientEventType
        );
      });
  }

  getUnreadNotification() {
    this.notificationService.isHaveUnread().subscribe((res) => {
      if (res.isHaveUnread) {
        this.readNotify = '1';
        this.sharedStateService.setIsHaveUnreadNotificationState(true);
      } else {
        // this.readNotify = '0';
        // this.sharedStateService.setIsHaveUnreadNotificationState(false);
      }

      if (res.total > 10) {
        this.totaUnreadlNotifications = '10+';
      } else {
        this.totaUnreadlNotifications = (res.total || 0).toString();
      }

      this.doSubcribeEmegency();
    });
  }

  handleRedirectToHomePage() {
    this.router.navigateByUrl('/home');
  }

  async doSubcribeEmegency() {
    if (this.isSubscribedNotification) return;

    this.signalRService.notificationMessages$.subscribe(
      async (notifications: any) => {
        if (notifications != null && notifications.length > 0) {
          this.readNotify = '1';
          this.sharedStateService.setIsHaveUnreadNotificationState(true);
          this.getUnreadNotification();
        }
      }
    );
    this.isSubscribedNotification = true;
  }

  handleRedirectToProfile() {
    if (this.authService.isAdminUser || this.authService.isClientUser)
      this.router.navigateByUrl('/main/profile');
    else this.router.navigateByUrl('/knight/profile');
  }

  async handleShowNotifications() {
    // this.popover = await this.modalCtrl.create({
    //   component: NotificationListPage,
    //   cssClass: 'modal-full-width',
    // });
    // await this.popover.present();
    // this.popover.onDidDismiss()
    //   .then(() => {
    //     if (this.notificationService.getPermissionValue() != 'granted') {
    //       this.notificationService.getUnread()
    //         .subscribe(res => {
    //           this.readNotify = (res > 10 ? '10+' : res?.toString())
    //         })
    //     }
    //     this.popover = null;
    //   });

    const modal = await this.modalCtrl.create({
      component: NotificationDialogComponent,
      // cssClass: 'fullscreen-modal',
      componentProps: {
        data: { latitude: null, longitude: null, userId: null },
      },
    });
    await modal.present();

    // this.readNotify = '0';
    modal.onDidDismiss().then((res) => {
      this.getUnreadNotification();
    });
  }

  async openSetting(option: any){
    await KioskMode.openSetting({type: option});
  }

  async openSubMenu(ev: Event) {
    const popover = await this.popoverController.create({
      component: SettingSubmenuPopoverComponent,
      event: ev,
      translucent: true,
      showBackdrop: true
    });
    await popover.present();
    const { data, role } = await popover.onDidDismiss();
    if(data){
      this.openSetting(data);
    }
  }
}
